import { BaseEntity } from "app/core/models/base-entity.model";

export class InsuredNotificationDetail extends BaseEntity {
    notificationId: number;
    claimId: number;
    documentId: number;
    sinesterNumber: number;
    claimNumber: number;
    docket: string;
    documentType: string;
    caseFileNumber: string;
    assignedDate: Date;
    assignedDateString: string;
    visualized: string;
    dtVisualized?: Date | null;
    userIdVisualized?: number | null;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/insuredNotificationDetail.ts